import type { ClientLegalAgreementState } from '../components/PlatformLegalDocumentsAcceptSection';
import {
  CLIENT_LEGAL_DOCUMENT_IDS,
  createEmptyClientLegalAgreementState,
  isClientLegalAgreementComplete,
} from '../components/PlatformLegalDocumentsAcceptSection';
import { profileStorageKey } from './profileStorageKey';

const STORAGE_KEY_PREFIX = 'ofrontend.profileCompletionLegal';

function storageKey(loginId?: string | null): string {
  return profileStorageKey(STORAGE_KEY_PREFIX, loginId);
}

export function readProfileCompletionLegal(
  loginId?: string | null,
): ClientLegalAgreementState {
  const empty = createEmptyClientLegalAgreementState();
  try {
    const raw = localStorage.getItem(storageKey(loginId));
    if (!raw?.trim()) {
      return empty;
    }
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return empty;
    }
    const record = parsed as Record<string, unknown>;
    const next = { ...empty };
    for (const documentId of CLIENT_LEGAL_DOCUMENT_IDS) {
      next[documentId] = record[documentId] === true;
    }
    return next;
  } catch {
    return empty;
  }
}

export function persistProfileCompletionLegal(
  agreed: ClientLegalAgreementState,
  loginId?: string | null,
): void {
  try {
    localStorage.setItem(storageKey(loginId), JSON.stringify(agreed));
  } catch {
    /* quota / private mode */
  }
}

export function profileCompletionLegalIsComplete(loginId?: string | null): boolean {
  return isClientLegalAgreementComplete(readProfileCompletionLegal(loginId));
}
